"use client";

import { useBranding } from "@/lib/tenant/context";

export function Footer() {
  const branding = useBranding();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t bg-white dark:bg-plantista-950 border-gray-200 dark:border-plantista-900 transition-colors duration-300">
      <div className="container mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold text-plantista-950 dark:text-white mb-3 font-display">
              {branding.companyName || "Plantista"}
            </h3>
            <p className="text-plantista-600 dark:text-plantista-400 text-sm leading-relaxed">
              AI-powered garden design made simple
            </p>
          </div>

          <div>
            <h3 className="font-bold text-plantista-950 dark:text-white mb-3 font-display">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/faq"
                  className="text-sm text-plantista-600 dark:text-plantista-300 hover:text-plantista-900 dark:hover:text-white transition"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="text-sm text-plantista-600 dark:text-plantista-300 hover:text-plantista-900 dark:hover:text-white transition"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-sm text-plantista-600 dark:text-plantista-300 hover:text-plantista-900 dark:hover:text-white transition"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-plantista-950 dark:text-white mb-3 font-display">
              Powered By
            </h3>
            <a
              href="https://plantista.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-plantista-600 dark:text-plantista-300 hover:text-plantista-900 dark:hover:text-white transition"
            >
              Plantista.ai
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-plantista-900 text-center">
          <p className="text-sm text-plantista-600 dark:text-plantista-500">
            © {currentYear} {branding.companyName || "Plantista"}. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
